/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespSidebarSellerInfo_seller$ref = any;
export type PdpRespSidebarSellerInfo_seller = {
    readonly monthsSinceStartDate: number | null;
    readonly serviceId: string | null;
    readonly isDistinguished: boolean | null;
    readonly isRewardsTier2: boolean | null;
    readonly sellerTiers: {
        readonly isGoldTier: boolean | null;
        readonly isPlatinumTier: boolean | null;
        readonly sellerTierDataNotFound: boolean | null;
    } | null;
    readonly orderFeedbackPdp: {
        readonly metadata: {
            readonly aggregatedFeedback: {
                readonly overallExperience: {
                    readonly mean: number | null;
                } | null;
            } | null;
        } | null;
    } | null;
    readonly sellerProfile: {
        readonly company: string | null;
    } | null;
    readonly tradeAssociations: ReadonlyArray<{
        readonly serviceId: string | null;
    } | null> | null;
    readonly " $refType": PdpRespSidebarSellerInfo_seller$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "PdpRespSidebarSellerInfo_seller",
        "type": "Seller",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": "monthsSinceStartDate",
                "name": "timeSinceStartDate",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "unit",
                        "value": "MONTH"
                    }
                ],
                "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
            },
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isDistinguished",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": "isRewardsTier2",
                "name": "isAnchorListMember",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "listName",
                        "value": "SELLER_REWARDS_2"
                    }
                ],
                "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "sellerTiers",
                "storageKey": null,
                "args": null,
                "concreteType": "SellerTiers",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isGoldTier",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isPlatinumTier",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "sellerTierDataNotFound",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "orderFeedbackPdp",
                "storageKey": null,
                "args": null,
                "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "metadata",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "aggregatedFeedback",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "AggregatedOrderFeedbackType",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "overallExperience",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "AggregatedOrderFeedbackQuestionType",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "mean",
                                                "args": null,
                                                "storageKey": null
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "sellerProfile",
                "storageKey": null,
                "args": null,
                "concreteType": "SellerProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "company",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "tradeAssociations",
                "storageKey": null,
                "args": null,
                "concreteType": "TradeAssociation",
                "plural": true,
                "selections": [
                    (v0 /*: any*/)
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'a1d2c2fa4b00c54f489cb53e95923a2d';
export default node;
